import { createSlice } from '@reduxjs/toolkit';
import { MapWaterSystemMetrics } from '../../../types';
import { fetchMapWaterSystemMetricsAsync, fetchMapWaterSystemMetricsAsyncBuilder } from './asyncRequests'


export interface MapWaterSystemsMetricsInitialState {
  data: MapWaterSystemMetrics[];
  loading: boolean;
  error: string;
  success: boolean;
}

const initialState: MapWaterSystemsMetricsInitialState = {
  data: [],
  loading: false,
  error: '',
  success: false,
}

export const MapWaterSystemsMetricsSlice = createSlice({
  name: 'mapWaterSystemMetricsSlice',
  initialState,
  reducers: {
    resetMapWaterSystemMetricsData: (state) => {
      state.data = initialState.data
    }
  },
  extraReducers: (builder) => {
    fetchMapWaterSystemMetricsAsyncBuilder(builder);
  },
})

export const MapWaterSystemsMetricsActions = {
  ...MapWaterSystemsMetricsSlice.actions,
  fetchMapWaterSystemMetricsAsync,
}

export const MapWaterSystemsMetricsReducer = MapWaterSystemsMetricsSlice.reducer;
